
import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import InputType from "common/form/InputType";
import { FragmentProvider } from "core/components/FragmentProvider";
import { IFragmentLayoutConfig } from "../../../core/components/FragmentLayout";
import { ICourseParams } from "../entities/CourseParams";
import * as badgeFragments from "../fragments/badge/displayFragments";
import * as itemContainerFragments from "../fragments/container/itemContainerFragments";
import * as parentContainerFragments from "../fragments/container/parentContainerFragments";
import * as actionFragments from "../fragments/course/actionFragments";
import * as compositeFragments from "../fragments/course/compositeFragments";
import * as displayFragments from "../fragments/course/displayFragments";
import * as filterFragments from "../fragments/filterFragments";
import * as generalFragments from "../fragments/generalFragments";
import CourseParamsField from "./CourseParamsField";

// tslint:disable:max-classes-per-file

@Entity({many: "tagSets"})
class TagSet {
	@Field() public id: any;
	@Field() public name: string;
}

const tagSetSelect = EntityMultiSelect.registered(TagSet, {}, { lazyLoad: true });

const generalFragmentsInput = FragmentProvider.getLayoutInput({...generalFragments, ...filterFragments});
const containerFragmentsInput = FragmentProvider.getInput(parentContainerFragments);
const itemFragmentInput = FragmentProvider.getInput(itemContainerFragments);
const courseFragmentsInput = FragmentProvider.getLayoutInput({...displayFragments, ...actionFragments, ...compositeFragments});
const badgeDisplayField = FragmentProvider.getLayoutInput(badgeFragments);

@Form({title: "Bundle Entries Config"})
export default class CourseListPanelConfig {

	@Input({type: CourseParamsField, title: "Filters"})
	public preselectedParams: ICourseParams;

	@Input({type: InputType.CHECKBOX, title: "Include Page Params"})
	public includePageParams?: boolean;

	@Input({type: generalFragmentsInput, title: "Main Layout"})
	public mainLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: containerFragmentsInput, title: "Container Type"})
	public containerFragment: string;

	@Input({type: itemFragmentInput, title: "Item Wrapper Type"})
	public itemFragment: string;

	@Input({type: courseFragmentsInput, title: "Course Layout"})
	public courseFragmentLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: badgeDisplayField, title: "Badge Layout"})
	public badgeLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: tagSetSelect, title: "Tag Sets For Course Tag Display"})
	public tagSetIds: any[];

	@Input({type: InputType.CHECKBOX, title: "Only Show Future-Dated Products", description: "this is controlled by the display start date product field"})
	public futureProductsOnly: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show new banner", description: "catalog entry published in last thrity days"})
	public newBanner: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Disable Direct buy", description: "disable redirect to 3rd party cart"})
	public disableDirectBuy: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Login Before Buy", description: "prompts for sso upon buy for non logged-in user and redirects to course details page after sso"})
	public loginBeforeBuy: boolean = false;

	@Input({type: InputType.TEXT, title: "SSO Redirect Page Upon Buy", description: "Redirects the non logged in user here on click buy button. example value: course-details"})
	public buySSORedirectPage: string;

	@Input({type: InputType.TEXT, title: "Show Custom fields"})
	public showCustomFields: string;
}





// WEBPACK FOOTER //
// ./src/panels/catalog/config/CourseListPanelConfig.ts